AFRAME.registerComponent('scene1', {
  schema: {
    sceneModel: {default: ''},
    nftTextureSrc: {default: ''},
    frameStyle: {default: 1, min: 1, max: 10},
    roomStyle: {default: 1, min: 1, max: 4},
    aspectRatio: {default: 'squared', oneOf: ['squared', 'portrait', 'landscape']},
    nftColors: {default: false},
  },

  textures: [
    './assets/textures/scene1/style1.jpg',
    './assets/textures/scene1/style2.jpg',
    './assets/textures/scene1/style3.jpg',
    './assets/textures/scene1/style4.jpg',
    './assets/textures/scene1/lightmap-landscape.jpg',
    './assets/textures/scene1/lightmap-portrait.jpg',
    './assets/textures/scene1/lightmap-squared.jpg'
  ],

  cameraAnimations: [
    {
      fov: 70,
      initialPosition: new THREE.Vector3(-2.1, 1.7, 0.16),
      initialRotation: new THREE.Vector3(-2.6, -18, 0),
      finalPosition: new THREE.Vector3(-0.8, 1.7, 0.6),
      finalRotation: new THREE.Vector3(-2.6, -18, 0),
      duration: 5000
    },
    {
      initialPosition: new THREE.Vector3(0, 1.7, -1),
      initialRotation: new THREE.Vector3(0, 0, 0),
      finalPosition: new THREE.Vector3(0, 1.7, 0.2),
      finalRotation: new THREE.Vector3(0, 0, 0),
      duration: 5000
    },
    {
      fov: 70,
      initialPosition: new THREE.Vector3(2.23, 1, -0.7),
      initialRotation: new THREE.Vector3(-0.11, 33.8, 0),
      finalPosition: new THREE.Vector3(1.4, 1, -0.22),
      finalRotation: new THREE.Vector3(-0.11, 33.8, 0),
      duration: 5000
    },
    {
      fov: 45,
      initialPosition: new THREE.Vector3(-0.42, 0.8, 1.7),
      initialRotation: new THREE.Vector3(9.96, -1.6, 0),
      finalPosition: new THREE.Vector3(-0.3, 0.8, 0.77),
      finalRotation: new THREE.Vector3(9.96, -1.6, 0),
      duration: 5000
    }
  ],

  init: function () {
    var system = this.el.sceneEl.systems.scene;
    this.onModelLoaded = system.onModelLoaded.bind(this);
    this.onTexturesPreloaded = this.onTexturesPreloaded.bind(this);
    this.el.sceneEl.addEventListener('texturespreloaded', this.onTexturesPreloaded);
    this.el.addEventListener('model-loaded', this.onModelLoaded);
    this.el.setAttribute('gltf-model', this.data.sceneModel);
    system.registerScene(this.el);
    system.initCanvasTextures(this);

    this.materials = {};
  },

  update: function () {
    var system = this.el.sceneEl.systems.scene;
    system.updateModel(this);
  },

  onTexturesPreloaded: function () {
    this.texturesPreloaded = true;
  }
});